import type { FaireProductEntity } from "../../entity_types/product";

export const p_ae1cdyg9: FaireProductEntity = {
  token: "p_ae1cdyg9",
  type: "product",
  name: "Body Balm Candle / White Woods (60 g) Lotion Candle",
  brandToken: "b_f4k7amd5",
  brandName: "Bonnie Skincare",
  imageUrl:
    "https://cdn.faire.com/fastly/cda133cfffb9bc4d2400443dd660727d193787132ae8aaa139b926763a47269e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bde69701c693805a1a483c518fd5a847a3f1879143bc5034516be04a287a381.jpeg",
    "https://cdn.faire.com/fastly/3c7293a13db157a697acf8431dcbae88b1457870b5d6a45c9a9cb3b4294accea.jpeg",
    "https://cdn.faire.com/fastly/02f75173b2dfe46c6fe49765107700b652f9364cca7fb7be0b4f7e28f4b7882c.jpeg",
    "https://cdn.faire.com/fastly/259b15756fd71a49b282cbbe93823b915a8d1f4aee59ee6706f0c5fcbbc61036.jpeg",
  ],
  priceDollars: 9,
  description:
    "White Woods\n\nOur most popular fragrance. Clean white musk floats above cedar and vetiver.\n\nTop: Cotton, white musk\nHeart: Black wild spruce\nBase: Cedarwood, vetiver\n\n\nSmall Tumbler (60 g)\n\nA unique gift or luxurious treat, Bonnie Body Balm Candles melt into a warm liquid that can be used as a deeply moisturizing body lotion or massage oil.\n\nBody Balm Candles use specific proportions of pure soy wax to fuel the flame and plant-based butters and oils to provide skin-nourishing moisture.\n\nHow to enjoy: After lighting, wait for a wax pool to form. Dip fingertip into wax and massage onto dry skin.\n\n\n\nIngredients: Soy wax, organic sunflower oil, shea butter, cocoa butter, fragrance (phthalate free), essential oil blend",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:00.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
